import moment from 'moment'
import { useLayoutEffect, useState } from 'react'
import type { GameBoxRoom } from '../../../services/games/games-boxes-rooms/types'

export function useCheckExpiredCoinDrop(gameBoxRoom: GameBoxRoom) {
  const [allowRescue, setShouldAllowRescue] = useState(false)

  useLayoutEffect(() => {
    if (!allowRescue) {
      const dateFinalDistribute = moment(gameBoxRoom?.dateFinalDistribute)

      const diffTimeExpired = moment.duration(
        dateFinalDistribute.diff(moment()),
      )

      const isExpired = diffTimeExpired.asMinutes() <= 0

      if (isExpired) {
        const dateLimitToRescue = moment(gameBoxRoom?.dateLimitToRescue)
        const diffTime = moment.duration(dateLimitToRescue.diff(moment()))
        const allow = diffTime.asMinutes() >= -15

        setShouldAllowRescue(allow)
      }
    }
  }, [
    allowRescue,
    gameBoxRoom?.dateFinalDistribute,
    gameBoxRoom?.dateLimitToRescue,
  ])

  return {
    allowRescue,
    setShouldAllowRescue,
  }
}
